
<lib-payment-booking [intent]="intent" (goto)="onChangeView($event)" *ngIf="viewControl.bookingView.visible" (book)="onBook($event)"></lib-payment-booking>
<lib-payment-shopping-cart [intent]="intent" (goto)="onChangeView($event)" *ngIf="viewControl.shoppingCartView.visible"></lib-payment-shopping-cart>
<lib-payment-wallet *ngIf="viewControl.walletView.visible" ></lib-payment-wallet>
